import { render, staticRenderFns } from "./ContasBancariasTable.vue?vue&type=template&id=b0295508"
import script from "./ContasBancariasTable.vue?vue&type=script&lang=js"
export * from "./ContasBancariasTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports